import React from 'react';
// import { WEATHER_PAGE_SIZE } from 'ots-constants';
import { IGridBodyProps } from 'components/common/Grid/types';
// import AdvertisementBlock from 'components/common/Grid/AdvertisementBlock';
import GridRow from './GridRow';

import styles from './styles.module.scss';

// const AD_EVERY_COUNT = 6;

const GridBody = ({
  data,
  columns,
  // total,
  noValueSymbol,
  // noAd,
}: IGridBodyProps) => (
  <tbody>
    {data.map((item, index) => (
    // const count = index + 1;
    // const isADTimeByOrder = count % AD_EVERY_COUNT === 0; // Every AD_EVERY_COUNT
    // const isADWasNotAddedAtTheEnd = count % AD_EVERY_COUNT < AD_EVERY_COUNT / 2;
    // const isFirstPage = count < WEATHER_PAGE_SIZE;
    // const isFirstInBlock = index === 0;
    // const isLast = count === total;
    // const isInLastAdEveryCount = count >= total - AD_EVERY_COUNT / 2;
    // show AD after last Element if no AD added between last AD_EVERY_COUNT/2 items
    // to not divide last element from other fields

      // const shouldShowAd = !noAd && ((isADTimeByOrder && (!isFirstPage || !isFirstInBlock) && !isInLastAdEveryCount)
      //     || (isLast && isADWasNotAddedAtTheEnd));

      <React.Fragment key={item.resort?.uuid || item.uuid}>
        <GridRow
          rowData={item}
          columns={columns}
          className={(index) % 2 ? '' : styles.other}
          noValueSymbol={noValueSymbol}
        />
        {/* {shouldShowAd && <AdvertisementBlock />} */}
      </React.Fragment>
    ))}
  </tbody>
);

export default GridBody;
